import {
  IssueDocument,
  IssueQuery,
  IssueQueryVariables,
  IssueRefFragment,
  IssueRefFragmentDoc,
  withStandardRefHook,
} from '@spotify/confidence-graphql';

export const useIssueRef = withStandardRefHook<
  IssueQuery,
  IssueRefFragment,
  'issue',
  IssueQueryVariables
>(
  IssueDocument,
  'issue',
  IssueRefFragmentDoc,
  'IssueRef',
  'ObservationsV1Issue',
);
